import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { deleteKhedmat, changeKhadamtSearch } from "Stores/actions";
import { SAVE_ALL_KHEDMAT } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteKhadamat({ row }) {
  const { khedmatData, khedmatDataPagination } = useSelector((state) => ({
    khedmatData: state.khedmat.khedmatData,
    khedmatDataPagination: state.khedmat.khedmatDataPagination,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteKhedmat(data, row.Name));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_ALL_KHEDMAT,
          khedmatData: khedmatData.filter((item) => item.Id !== row.Id),
          khedmatDataPagination: khedmatDataPagination,
        });
        dispatch(changeKhadamtSearch({ Name: "" }));
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={
          (row.IsG &&
              read("StypeU") !== "1") ||
              read("khadamatRules")?.accessDelete === false ||
          row.Disable
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        loading={loading}
      />
    </>
  );
}

export default DeleteKhadamat;
